/*
  お客様の声 / Judge.me レビュー一覧
  ------------------------------------------------------------
  sections/jaune-reviews.liquid とペア。Judge.me 公開API
  （widgets/all_reviews_page）を全ページ分取得し、最低★で絞り、
  並び替え、12件ずつ「もっと見る」で表示する。装飾は jaune.css（37番）。

  MANUAL_REVIEWS: Judge.meの公開APIはショップ（お店自体）宛のレビューを
  ヘッダーの件数には含めるが、本文一覧には返さない制約があるため、
  ショップレビューが来たときはここに手打ちで追加して他と同じ見た目で混ぜる。
  Judge.me管理画面の「すべてのレビュー」件数と表示件数が一致していれば
  このリストは空のままでOK。件数がずれたらここを見直す。
*/
var MANUAL_REVIEWS = [
  {
    score: 5,
    date: '2026-09-14',
    author: '匿名',
    location: '',
    verified: true,
    title: '',
    body: 'おふたりのオンラインショップオープンを楽しみにしてました。写真、商品説明、梱包、そして商品ももちろん、全てにおいてとても丁寧で最高でした！人柄がにじみ出たショップですね。<br>これからも引き続き楽しみにしてます♪'
  }
];

(function () {
  function init(root) {
    if (root.dataset.jrReady) return;
    root.dataset.jrReady = '1';

    var CFG = {
      token:     root.dataset.token || '',
      shop:      root.dataset.shop || '',
      minRating: parseInt(root.dataset.minRating || '1', 10),
      batch:     parseInt(root.dataset.batch || '12', 10),
      sort:      root.dataset.sort || 'newest',
      photos:    root.dataset.photos === 'true',
      product:   root.dataset.product === 'true',
      perPage:   50,
      maxPages:  40
    };

    var listEl    = root.querySelector('[data-jr-list]');
    var moreWrap  = root.querySelector('[data-jr-more-wrap]');
    var moreBtn   = root.querySelector('[data-jr-more]');
    var countEl   = root.querySelector('[data-jr-count]');
    var avgStars  = root.querySelector('[data-jr-avg-stars]');
    var summaryEl = root.querySelector('[data-jr-summary]');
    var controls  = root.querySelector('[data-jr-controls]');
    var loadingEl = root.querySelector('[data-jr-loading]');
    var emptyEl   = root.querySelector('[data-jr-empty]');
    var errorEl   = root.querySelector('[data-jr-error]');
    var sortBtns  = root.querySelectorAll('[data-jr-sort-btn]');

    var lb      = root.querySelector('[data-jr-lightbox]');
    var lbImg   = root.querySelector('[data-jr-lb-img]');
    var lbClose = root.querySelector('[data-jr-lb-close]');

    var ALL = [];      // { score, date, html }
    var shown = 0;

    if (!CFG.token || !CFG.shop) { fail(); return; }

    function api(page) {
      return 'https://judge.me/api/v1/widgets/all_reviews_page'
        + '?api_token=' + encodeURIComponent(CFG.token)
        + '&shop_domain=' + encodeURIComponent(CFG.shop)
        + '&per_page=' + CFG.perPage
        + '&page=' + page;
    }

    function stars(score) {
      var n = Math.round(score);
      var s = '';
      for (var i = 1; i <= 5; i++) s += (i <= n) ? '★' : '<span class="off">★</span>';
      return s;
    }

    function fmtDate(d) {
      if (!d || isNaN(d)) return '';
      var y = d.getFullYear();
      var m = ('0' + (d.getMonth() + 1)).slice(-2);
      var day = ('0' + d.getDate()).slice(-2);
      return y + '.' + m + '.' + day;
    }

    function esc(t) {
      return (t || '').replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    function parseHeader(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var h = doc.querySelector('.jdgm-all-reviews__header');
      if (!h) return;
      var n = h.getAttribute('data-number-of-reviews');
      var avg = parseFloat(h.getAttribute('data-average-rating') || '0');
      if (n != null && countEl) countEl.textContent = n;
      if (avg && avgStars) avgStars.innerHTML = stars(avg);
      if (summaryEl) summaryEl.hidden = false;
    }

    function buildReview(rev) {
      var ratingEl = rev.querySelector('.jdgm-rev__rating');
      var score = ratingEl ? parseFloat(ratingEl.getAttribute('data-score') || '0') : 0;

      var tsEl = rev.querySelector('.jdgm-rev__timestamp');
      var raw = tsEl ? (tsEl.getAttribute('data-content') || '') : '';
      var date = raw ? new Date(raw.replace(' UTC', 'Z').replace(' ', 'T')) : null;

      var authorEl = rev.querySelector('.jdgm-rev__author');
      var author = authorEl ? authorEl.textContent.trim() : '匿名';
      var locEl = rev.querySelector('.jdgm-rev__location');
      var loc = locEl ? locEl.textContent.trim() : '';
      var titleEl = rev.querySelector('.jdgm-rev__title');
      var title = titleEl ? titleEl.textContent.trim() : '';
      var bodyEl = rev.querySelector('.jdgm-rev__body');
      var bodyHTML = bodyEl ? bodyEl.innerHTML : '';

      var verified = rev.getAttribute('data-verified-buyer') === 'true'
        || !!rev.querySelector('.jdgm-rev__buyer-badge');

      var prodLink = rev.querySelector('.jdgm-rev__prod-link');
      var prodName = prodLink ? prodLink.textContent.trim() : '';
      var prodHref = prodLink ? prodLink.getAttribute('href') : '';

      var pics = [];
      rev.querySelectorAll('.jdgm-rev__pics img, .jdgm-rev__pic-img').forEach(function (img) {
        var thumb = img.getAttribute('data-src') || img.getAttribute('src') || '';
        var a = img.closest('a');
        var full = (a && a.getAttribute('href')) || thumb;
        if (thumb) pics.push({ thumb: thumb, full: full });
      });

      var html = '';
      html += '<li class="jr-rev">';
      html +=   '<div class="jr-rev__top">';
      html +=     '<span class="jr-rev__rating" aria-label="5段階中' + Math.round(score) + '">' + stars(score) + '</span>';
      html +=     '<span class="jr-rev__author">' + esc(author) + (loc ? '（' + esc(loc) + '）' : '') + '</span>';
      if (date) html += '<span class="jr-rev__date">' + fmtDate(date) + '</span>';
      if (verified) html += '<span class="jr-rev__verified">確認済みの購入</span>';
      html +=   '</div>';
      html +=   '<div class="jr-rev__main">';
      html +=     '<div class="jr-rev__text">';
      if (title) html += '<span class="jr-rev__title">' + esc(title) + '</span>';
      html +=       '<div class="jr-rev__body">' + bodyHTML + '</div>';
      if (CFG.product && prodName && prodHref) {
        html +=     '<a class="jr-rev__prod" href="' + esc(prodHref) + '">' + esc(prodName) + '</a>';
      }
      html +=     '</div>';
      if (CFG.photos && pics.length) {
        html +=   '<div class="jr-rev__pics">';
        pics.forEach(function (p) {
          html += '<button type="button" class="jr-rev__pic" data-full="' + esc(p.full) + '">'
               +  '<img src="' + esc(p.thumb) + '" alt="" loading="lazy"></button>';
        });
        html +=   '</div>';
      }
      html +=   '</div>';
      html += '</li>';

      return { score: score, date: date ? date.getTime() : 0, html: html };
    }

    function buildManualReview(m) {
      var d = new Date(m.date);
      var html = '';
      html += '<li class="jr-rev">';
      html +=   '<div class="jr-rev__top">';
      html +=     '<span class="jr-rev__rating" aria-label="5段階中' + Math.round(m.score) + '">' + stars(m.score) + '</span>';
      html +=     '<span class="jr-rev__author">' + esc(m.author) + (m.location ? '（' + esc(m.location) + '）' : '') + '</span>';
      if (!isNaN(d)) html += '<span class="jr-rev__date">' + fmtDate(d) + '</span>';
      if (m.verified) html += '<span class="jr-rev__verified">確認済みの購入</span>';
      html +=   '</div>';
      html +=   '<div class="jr-rev__main">';
      html +=     '<div class="jr-rev__text">';
      if (m.title) html += '<span class="jr-rev__title">' + esc(m.title) + '</span>';
      html +=       '<div class="jr-rev__body"><p>' + m.body + '</p></div>';
      html +=     '</div>';
      html +=   '</div>';
      html += '</li>';
      return { score: m.score, date: isNaN(d) ? 0 : d.getTime(), html: html };
    }

    function sortAll() {
      ALL.sort(function (a, b) {
        if (CFG.sort === 'highest') return (b.score - a.score) || (b.date - a.date);
        return b.date - a.date;
      });
    }

    function render(reset) {
      if (reset) { listEl.innerHTML = ''; shown = 0; }
      var slice = ALL.slice(shown, shown + CFG.batch);
      var frag = document.createElement('div');
      frag.innerHTML = slice.map(function (r) { return r.html; }).join('');
      while (frag.firstChild) listEl.appendChild(frag.firstChild);
      shown += slice.length;
      if (moreWrap) moreWrap.hidden = shown >= ALL.length;
    }

    if (listEl) {
      listEl.addEventListener('click', function (e) {
        var btn = e.target.closest('.jr-rev__pic');
        if (!btn || !lb) return;
        lbImg.src = btn.getAttribute('data-full');
        lb.classList.add('is-open');
      });
    }
    function closeLb() { if (!lb) return; lb.classList.remove('is-open'); lbImg.src = ''; }
    if (lb) {
      lbClose.addEventListener('click', closeLb);
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });
    }

    Array.prototype.forEach.call(sortBtns, function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-jr-sort-btn');
        if (val === CFG.sort) return;
        CFG.sort = val;
        Array.prototype.forEach.call(sortBtns, function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        sortAll();
        render(true);
      });
    });

    if (moreBtn) moreBtn.addEventListener('click', function () { render(false); });

    function fail() {
      if (loadingEl) loadingEl.hidden = true;
      if (errorEl) errorEl.hidden = false;
    }

    function finish() {
      if (loadingEl) loadingEl.hidden = true;
      if (!ALL.length) { if (emptyEl) emptyEl.hidden = false; return; }
      if (controls) controls.hidden = false;
      sortAll();
      render(true);
    }

    MANUAL_REVIEWS.forEach(function (m) {
      var built = buildManualReview(m);
      if (built.score >= CFG.minRating) ALL.push(built);
    });

    (function loadAll() {
      var page = 1;
      var parser = new DOMParser();

      function next() {
        if (page > CFG.maxPages) return finish();
        fetch(api(page))
          .then(function (r) {
            if (!r.ok) throw new Error('http ' + r.status);
            return r.json();
          })
          .then(function (data) {
            if (page === 1) parseHeader(data.all_reviews_header);
            var chunk = (data.all_reviews || '').trim();
            if (!chunk) return finish();
            var doc = parser.parseFromString('<div>' + chunk + '</div>', 'text/html');
            var revs = doc.querySelectorAll('.jdgm-rev');
            if (!revs.length) return finish();
            Array.prototype.forEach.call(revs, function (rev) {
              var built = buildReview(rev);
              if (built.score >= CFG.minRating) ALL.push(built);
            });
            if (revs.length < CFG.perPage) return finish();
            page++;
            next();
          })
          .catch(function (err) {
            if (window.console) console.error('[jaune-reviews]', err);
            if (!ALL.length) fail(); else finish();
          });
      }
      next();
    })();
  }

  function boot() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-jaune-reviews]'), init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // テーマエディタでセクションを再読み込みした場合に対応
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-jaune-reviews]');
    if (el) init(el);
  });
})();
